import template from "./date-format-selector.html";
import dateFormats from "../../../../server/config/dateFormats";

const DateFormatSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class DateFormatSelectorComponent {
    /* @ngInject */
    constructor($scope, moment) {
      this.$scope = $scope;
      this.moment = moment;
    }

    $onInit() {
      this.setDateFormats();
      this.dateFormat = this.defaultValue || dateFormats[0];

      this.$scope.$watch(
        () => this.dateFormat,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.onChange({
              oldDateFormat: oldVal,
              newDateFormat: this.dateFormat,
            });
        }
      );
    }

    setDateFormats() {
      this.dateFormats = dateFormats.map((format) => ({
        format: format,
        example: this.moment().format(format),
      }));
    }

    $onChanges(changesObj) {
      if (changesObj.defaultValue && !changesObj.defaultValue.isFirstChange())
        this.dateFormat = this.defaultValue;
    }
  },
};

export default DateFormatSelectorComponent;
